(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hello-world"] && !Shopify.designMode) return;
  try {
    
  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const windowLoadPromise = new Promise((resolve) => {
    if (document.readyState === 'complete') {
      resolve();
    } else {
      window.addEventListener('load', resolve, { once: true });
    }
  });

  Promise.all([windowLoadPromise, wait(2000)]).then(() => {
    const intro = document.querySelector('.intro');
    intro.classList.add('intro--loaded');

    const content = document.querySelector('.content');
    content.classList.remove('content--loading');
  });

  // Remove query parameters after successful form submission
  function cleanUrlAfterSuccess() {
    // Check if the success message is visible (form was submitted successfully)
    const successMessage = document.querySelector('.form__success');

    if (successMessage && window.location.search) {
      // Remove all query parameters from the URL without page refresh
      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
    }
  }

  // Run the URL cleanup when the page loads
  document.addEventListener('DOMContentLoaded', cleanUrlAfterSuccess);

  // Also run it after the intro animation completes, in case DOM wasn't ready
  Promise.all([windowLoadPromise, wait(2000)]).then(() => {
    cleanUrlAfterSuccess();
  });

  } catch(e) { console.error(e); }
})();
})();
